export default "__VITE_ASSET__vvswg_AF__"